module.exports = __webpack_public_path__ + "c85b406d6f2165574361ebbf79b4c60c.png";